import React, { SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import { TermsOfServiceAlert } from '../../../shared/components/alert/TermsOfServiceAlert';
import { Pagination } from '../../../shared/components/Pagination';
import { IMyCampaignsFilterProps } from '../campaign/dto/IMyCampaigns';
import ExploreOffersCard from './components/desktop/ExploreOffersCard';
import PlannerReports from './components/desktop/PlannerReportsCard';
import { IMyOffers } from './dto/IDashboard';
import { ICampaignOverview } from '../../../model/briefing/overview/ICampaignOverview';
import { ContractList } from './components/desktop/ContractList';
import OfferList from './components/desktop/OfferList';
import { IOfferWithCampaign } from '../profile/profile-view';
import { InvoiceDetailAlert } from '../../../shared/components/alert/InvoiceDetailAlert';
import InvoiceCard from './components/desktop/InvoiceCard';
import {
    ContractListSkeleton,
    ExploreOffersCardSkeleton,
    InvoiceCardSkeleton,
    PlannerReportsCardSkeleton,
} from './components/InfluencerDashboardSkeletons';

interface IDesktopDashboard {
    myOffers: IMyOffers;
    offers?: IOfferWithCampaign[];
    contractCampaigns?: ICampaignOverview[];
    filterParams: IMyCampaignsFilterProps;
    setFilterParams: React.Dispatch<SetStateAction<IMyCampaignsFilterProps>>;
    totalPages: number;
    handlePages: (updatePage: number) => void;
    isAgency?: boolean;
    isInvoiceModalOpen?: boolean;
    setIsInvoiceModalOpen?: React.Dispatch<SetStateAction<boolean>>;
    isSummaryLoading?: boolean;
    isContractsLoading?: boolean;
    isOffersLoading?: boolean;
}

const DesktopDashboard = ({
    myOffers,
    offers,
    setFilterParams,
    filterParams,
    handlePages,
    totalPages,
    isAgency,
    contractCampaigns,
    isInvoiceModalOpen,
    setIsInvoiceModalOpen,
    isSummaryLoading = false,
    isContractsLoading = false,
    isOffersLoading = false,
}: IDesktopDashboard) => {
    return (
        <div className="d-none d-md-block">
            <TermsOfServiceAlert />
            <InvoiceDetailAlert
                isBillingModalOpened={isInvoiceModalOpen}
                setIsBillingModalOpened={setIsInvoiceModalOpen}
            />
            <Row>
                <Col xl={4}>
                    {isSummaryLoading ? <ExploreOffersCardSkeleton /> : <ExploreOffersCard myOffers={myOffers} />}
                </Col>
                <Col xl={6} className="mt-3 mt-xl-0">
                    {isSummaryLoading ? <PlannerReportsCardSkeleton /> : <PlannerReports myOffers={myOffers} />}
                </Col>
                <Col sm={6} xl={2} className="mt-3 mt-xl-0">
                    {isSummaryLoading ? (
                        <InvoiceCardSkeleton />
                    ) : (
                        <InvoiceCard isAgency={!!isAgency} myOffers={myOffers} />
                    )}
                </Col>
            </Row>

            {isContractsLoading ? (
                <div className="mt-4">
                    <ContractListSkeleton />
                </div>
            ) : (
                !!contractCampaigns?.length && (
                    <div className="mt-4">
                        <ContractList campaigns={contractCampaigns} />
                    </div>
                )
            )}

            <div className="mt-4">
                <OfferList
                    offers={offers}
                    isAgency={isAgency}
                    filterParams={filterParams}
                    setFilterParams={setFilterParams}
                    isLoading={isOffersLoading}
                />
            </div>
            <div className="d-flex justify-content-end">
                {!isOffersLoading && totalPages > 1 && (
                    <Pagination page={filterParams.page} totalPages={totalPages} handlePagination={handlePages} />
                )}
            </div>
        </div>
    );
};

export default DesktopDashboard;
